if (!customElements.get('yola-purpose')) {
  customElements.define('yola-purpose', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const list = this.querySelector('[data-purpose-tabs]');
      const tabs = [...this.querySelectorAll('[data-purpose-tab]')];
      const panels = [...this.querySelectorAll('[data-purpose-panel]')];
      if (!list || tabs.length !== panels.length || !tabs.length) return;
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      list.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) {
            event.preventDefault();
            select(target, true);
          }
        });
      });
      select(0);
      list.hidden = false;
      this.dataset.ready = 'true';
    }
  });
}
